<template>
    <!-- 课票订单详情-票券订单列表  用户票券管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'buyOrder')">
            <div slot="header" class="buyOrder">
                <a-spin :spinning="spinning">
                    <div class="buyOrder-title mb16">交易信息</div>
                        <div class="buyOrder-content">
                            <a-row class="mb16">
                                <a-col :span="span">交易订单号：{{detailData.transNo}}</a-col>
                                <a-col :span="span">交易状态：{{orderDetail.tradeState}}</a-col>
                                <a-col :span="span">购买类型：{{$utils.category[detailData.category]}}</a-col>
                            </a-row>
                            <a-row class="mb16">
                                <a-col :span="span">手机号：{{detailData.phone}}</a-col>
                                <a-col :span="span">购买途径：{{detailData.platform}}</a-col>
                                <a-col :span="span">购买门店：{{detailData.shopName != "小程序" ? detailData.shopName : "-"}}</a-col>
                            </a-row>
                            <a-row class="mb16">
                                <a-col :span="span">收银台优惠使用：{{detailData.discountName || "-"}}</a-col>
                                <a-col :span="span">收银台优惠抵扣金额：{{detailData.discountAmount | myToFixed2}}</a-col>
                                <a-col :span="span">优惠券使用：{{detailData.couponName || "-"}}</a-col>
                            </a-row>
                            <a-row class="mb16">
                                <a-col :span="span">优惠券抵扣金额：{{detailData.couponAmount | myToFixed2}}</a-col>
                                <a-col :span="span"><span class="text-fail">应收金额：{{$utils.toFixed(detailData.transAmount, 2) | myToFixed2}}</span></a-col>
                                <a-col :span="span"><span class="text-fail">实收金额：{{$utils.toFixed(detailData.payAmount, 2) | myToFixed2}}</span></a-col>
                            </a-row>
                            <a-row class="mb16">
                                <a-col :span="span">下单时间：{{detailData.transTime || "-"}}</a-col>
                                <a-col :span="span">支付时间：{{detailData.payTime || "-"}}</a-col>
                                <a-col :span="span">支付方式：{{$utils.payMode[detailData.payMode] || "-"}}</a-col>
                            </a-row>
                            <a-row class="mb16">
                                <a-col :span="span">收银员：{{detailData.cashier || "-"}}</a-col>
                                <a-col :span="span"><span class="text-fail">应收积分：{{$utils.thousandSplit(detailData.transPoint) | isEmptyUnit("积分")}}</span></a-col>
                                <a-col :span="span"><span class="text-fail">实收积分：{{$utils.thousandSplit(detailData.payPoint) | isEmptyUnit("积分")}}</span></a-col>
                            </a-row>
                            <a-row class="mb16">
                                <a-col :span="span">是否人工确认：{{detailData.isManualPayment ? '是' : "否"}}</a-col>
                            </a-row>
                        </div>
                </a-spin>
            </div>
            <div class="">
                <a-card
                    class="card-box"
                    :bordered="false"
                    :tabList="tabListNoTitle"
                    :activeTabKey="noTitleKey"
                    @tabChange="key => onTabChange(key,'noTitleKey')"
                    >
                    <a-spin :spinning="spinning">
                        <template v-if="noTitleKey == 1">
                            <div class="mb16" v-if="detailData.category == 'Delay'">
                                <a-alert type="warning" show-icon>
                                    <template slot="message">
                                        <span class="text-color-65">过期续期不影响票本身的有效期，仅作为收款记录</span>
                                    </template>
                                </a-alert>
                            </div>
                            <template v-if="this.orderDetail.platformName == '第三方购买' && this.orderDetail.categoryEn == 'Buy' && isCanRefund">
                                <a-popconfirm
                                    title="请核对该订单是否已经完成客诉退款，退款成功的情况下，点击确定按钮，会将交易状态修改为“全部退款“，该订单下所有的票券都将变为禁用状态。"
                                    @confirm="confirm()"
                                    :overlayStyle="{width: '350px'}"
                                >
                                    <a-button class="mb24" type="primary">OTA客诉</a-button>
                                </a-popconfirm>
                            </template>
                            <template v-else>
                                <a-button class="mb24" :disabled="!Boolean(isCanRefund)" type="primary" @click="toRefundOrder">发起退款</a-button>
                            </template>
                            <template v-if="detailData.category == 'Frozen'">
                                <p>冻结</p>
                                <a-table bordered :dataSource="detailData.afterSalesData" :columns="columnsFrozen" :pagination="false" @change="changePage" :rowKey="(record, index) => index">
                                    <span slot="frozenDate" slot-scope="a, row">{{row.frozenStartDate}} ~ {{row.frozenEndDate}}</span>
                                    <span slot="originalValidTime" slot-scope="a, row">{{row.originalValidStartTime}} ~ {{row.originalValidEndTime}}</span>
                                    <span slot="nowValidTime" slot-scope="a, row">{{row.nowValidStartTime}} ~ {{row.nowValidEndTime}}</span>
                                </a-table>
                            </template>
                            <template v-if="detailData.category == 'ValidityReset'">
                                <p>有效期重置</p>
                                <a-table bordered :dataSource="detailData.afterSalesData" :columns="columnsValidityReset" :pagination="false" @change="changePage" :rowKey="(record, index) => index">
                                    <span slot="originalValidTime" slot-scope="a, row">{{row.beforeValidStartTime}} ~ {{row.beforeValidEndTime}}</span>
                                    <span slot="nowValidTime" slot-scope="a, row">{{row.afterValidStartTime}} ~ {{row.afterValidEndTime}}</span>
                                </a-table>
                            </template>
                            <template v-if="detailData.category == 'ExchangeCard'">
                                <p>票券补/换卡</p>
                                <a-table bordered :dataSource="detailData.afterSalesData" :columns="columnsExchangeCard" :pagination="false" @change="changePage" :rowKey="(record, index) => index">
                                    <span slot="originalValidTime" slot-scope="a, row">{{row.beforeValidStartTime}} ~ {{row.beforeValidEndTime}}</span>
                                    <span slot="nowValidTime" slot-scope="a, row">{{row.afterValidStartTime}} ~ {{row.afterValidEndTime}}</span>
                                </a-table>
                            </template>
                            <template v-if="detailData.category == 'ChangeCard'">
                                <p>会员补/换卡</p>
                                <a-table bordered :dataSource="detailData.afterSalesData" :columns="columnsExchangeCard" :pagination="false" @change="changePage" :rowKey="(record, index) => index">
                                    <span slot="originalValidTime" slot-scope="a, row">{{row.beforeValidStartTime}} ~ {{row.beforeValidEndTime}}</span>
                                    <span slot="nowValidTime" slot-scope="a, row">{{row.afterValidStartTime}} ~ {{row.afterValidEndTime}}</span>
                                </a-table>
                            </template>
                            <template v-if="detailData.category == 'Delay'">
                                <p>过期续期</p>
                                <a-table
                                    bordered
                                    :columns="columnsDelay"
                                    :dataSource="detailData.afterSalesData"
                                    :pagination="false"
                                    @change="changePage"
                                    :rowKey="(record, index) => record.businessId || index"
                                >
                                    <span slot="originalValidTime" slot-scope="a, row">{{row.ticketValidStartTime}} ~ {{row.ticketValidEndTime}}</span>
                                </a-table>
                            </template>
                            <template v-if="detailData.category != 'Upgrade' && dataSource.length">
                                <p class="mb16 mt16">主票明细</p>
                                <a-table bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="(record, index) => index">
                                    <span slot="category" slot-scope="category">{{$utils.category[category]}}</span>
                                    <span slot="invalidType" slot-scope="invalidType">{{$utils.uselessState[invalidType] || "-"}}</span>
                                    <span slot="ticketType" slot-scope="ticketType">{{['','期限卡','次卡', "套餐票"][ticketType] || "-"}}</span>
                                    <span slot="payAmounts" slot-scope="a, row">{{row.payAmount | myToFixed2}}</span>
                                    <span slot="total" slot-scope="a, row">{{row.total === -1 ? '不限次' : row.total || 0}}</span>
                                    <span slot="residueNum" slot-scope="a, row">{{row.residueNum === -1 ? '不限次' : row.residueNum || 0}}</span>
                                    <span slot="expireDay" slot-scope="a, row">{{row.expireDay && row.expireDay.substr(0,10)}}</span>
                                    <span slot="action" slot-scope="a, row">
                                        <span v-if="row.gifts && row.gifts.length">
                                            <span v-if="row.closeNavigate" class="text-disabled">赠品</span>
                                            <a v-else class="text-primary" @click="onClickGiveTicket(row.businessId)">赠品</a>
                                            <a-divider type="vertical"/>
                                        </span>
                                        <span v-if="getBtnByAuth('usingDetailUser')">
                                            <span v-if="row.closeNavigate" class="text-disabled">使用详情</span>
                                            <router-link v-else class="text-primary" :to="{name:'usingDetail', query: {userTicketId: row.businessId}}">使用详情</router-link>
                                            <a-divider type="vertical"/>
                                        </span>

                                        <span v-if="getBtnByAuth('operateRecord')">
                                            <span v-if="row.closeNavigate" class="text-disabled">操作记录</span>
                                            <router-link v-else class="text-primary" :to="{name:'operateRecordTicket', query: {userTicketId: row.businessId}}">操作记录</router-link>
                                            <a-divider type="vertical"/>
                                        </span>

                                        <span  v-if="getBtnByAuth('amendTicket')">
                                            <span v-if="row.closeNavigate" class="text-disabled">票券信息更改</span>
                                            <router-link v-else class="text-primary" :to="{name:'amendTicket', query: {id: row.businessId}}">票券信息更改</router-link>
                                        </span>
                                    </span>
                                </a-table>
                            </template>
                            <template v-if="detailData.category == 'Upgrade'">
                                <p class="mb24">升级后票</p>
                                <a-table bordered :dataSource="upgradeAfterTickets" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="(record, index) => index">
                                    <span slot="category" slot-scope="category">{{$utils.category[category]}}</span>
                                    <span slot="invalidType" slot-scope="invalidType">{{$utils.uselessState[invalidType]}}</span>
                                    <span slot="ticketType" slot-scope="ticketType">{{['','期限卡','次卡','套餐票'][ticketType]}}</span>
                                    <span slot="payAmounts" slot-scope="a, row">{{row.payAmount | myToFixed2}}</span>
                                    <span slot="total" slot-scope="a, row">{{row.total === -1 ? '不限次' : row.total || 0}}</span>
                                    <span slot="residueNum" slot-scope="a, row">{{row.residueNum === -1 ? '不限次' : row.residueNum || 0}}</span>
                                    <span slot="expireDay" slot-scope="a, row">{{row.expireDay && row.expireDay.substr(0,10)}}</span>
                                    <span slot="action" slot-scope="a, row">
                                        <span v-if="row.gifts && row.gifts.length">
                                            <span v-if="row.closeNavigate" class="text-disabled">赠品</span>
                                            <a v-else class="text-primary" @click="onClickGiveTicket(row.businessId)">赠品</a>
                                            <a-divider type="vertical"/>
                                        </span>
                                        <span v-if="getBtnByAuth('usingDetailUser')">
                                            <span v-if="row.closeNavigate" class="text-disabled">使用详情</span>
                                            <router-link v-else class="text-primary" :to="{name:'usingDetail', query: {userTicketId: row.businessId}}">使用详情</router-link>
                                            <a-divider type="vertical"/>
                                        </span>

                                        <span v-if="getBtnByAuth('operateRecord')">
                                            <span v-if="row.closeNavigate" class="text-disabled">操作记录</span>
                                            <router-link v-else class="text-primary" :to="{name:'operateRecordTicket', query: {userTicketId: row.businessId}}">操作记录</router-link>
                                            <a-divider type="vertical"/>
                                        </span>

                                        <span  v-if="getBtnByAuth('amendTicket')">
                                            <span v-if="row.closeNavigate" class="text-disabled">票券信息更改</span>
                                            <router-link v-else class="text-primary" :to="{name:'amendTicket', query: {id: row.businessId}}">票券信息更改</router-link>
                                        </span>
                                    </span>
                                </a-table>
                                <p class="mb24 mt24">升级前票</p>
                                <a-table bordered :dataSource="upgradeBeforeTickets" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="(record, index) => index">
                                    <span slot="category" slot-scope="category">{{$utils.category[category]}}</span>
                                    <span slot="invalidType" slot-scope="invalidType">{{$utils.uselessState[invalidType]}}</span>
                                    <span slot="ticketType" slot-scope="ticketType">{{['','期限卡','次卡','套餐票'][ticketType]}}</span>
                                    <span slot="payAmounts" slot-scope="a, row">{{row.payAmount | myToFixed2}}</span>
                                    <span slot="total" slot-scope="a, row">{{row.total === -1 ? '不限次' : row.total || 0}}</span>
                                    <span slot="residueNum" slot-scope="a, row">{{row.residueNum === -1 ? '不限次' : row.residueNum || 0}}</span>
                                    <span slot="expireDay" slot-scope="a, row">{{row.expireDay && row.expireDay.substr(0,10)}}</span>
                                    <span slot="action" slot-scope="a, row">
                                        <span v-if="row.gifts && row.gifts.length">
                                            <span v-if="row.closeNavigate" class="text-disabled">赠品</span>
                                            <a v-else class="text-primary" @click="onClickGiveTicket(row.businessId)">赠品</a>
                                            <a-divider type="vertical"/>
                                        </span>
                                        <span v-if="getBtnByAuth('usingDetailUser')">
                                            <span v-if="row.closeNavigate" class="text-disabled">使用详情</span>
                                            <router-link v-else class="text-primary" :to="{name:'usingDetail', query: {userTicketId: row.businessId}}">使用详情</router-link>
                                            <a-divider type="vertical"/>
                                        </span>

                                        <span v-if="getBtnByAuth('operateRecord')">
                                            <span v-if="row.closeNavigate" class="text-disabled">操作记录</span>
                                            <router-link v-else class="text-primary" :to="{name:'operateRecordTicket', query: {userTicketId: row.businessId}}">操作记录</router-link>
                                            <a-divider type="vertical"/>
                                        </span>

                                        <span  v-if="getBtnByAuth('amendTicket')">
                                            <span v-if="row.closeNavigate" class="text-disabled">票券信息更改</span>
                                            <router-link v-else class="text-primary" :to="{name:'amendTicket', query: {id: row.businessId}}">票券信息更改</router-link>
                                        </span>
                                    </span>
                                </a-table>
                            </template>
                        </template>
                        <div v-show="noTitleKey == 2">
                            <a-table bordered :dataSource="detailData.refundGoods" :columns="columnsRefund" :pagination="false" :rowKey="(record, index) => index">
                                <span slot="auditState" slot-scope="auditState">{{$utils.auditState[auditState + '']}}</span>
                                <span slot="state" slot-scope="state">{{['','退款中',successMsg,'退款失败'][state]}}</span>
                                <span slot="thirdPartyMsg" slot-scope="thirdPartyMsg">{{thirdPartyMsg || '--'}}</span>
                            </a-table>
                        </div>
                    </a-spin>
                </a-card>
            </div>
            <member-order-forbidden ref="forbiddenModal" @ok="getList"></member-order-forbidden>
            <orderRefund @resetList="getList" ref="orderRefund" :detailData="detailData" :orderData="orderDetail"></orderRefund>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script type="text/javascript">
    import { mapGetters } from "vuex";
    import remark from '@/components/modules/platform/remark.component';
    import memberOrderForbidden from '@/components/modules/order/member-order-forbidden.component';
    import orderRefund from "@/components/modules/order/order-refund.component";
    const columns = [
        {
            title: "用户票券号",
            dataIndex: "businessId",
            scopedSlots: { customRender: "businessId" }
        },
        {
            title: "票券名称",
            dataIndex: "goodsName"
        },

        {
            title: "票券状态",
            dataIndex: "ticketStateStr",
            scopedSlots: { customRender: "ticketStateStr" }
        },
        {
            title: "失效类型",
            dataIndex: "invalidType",
            scopedSlots: { customRender: "invalidType" }
        },
        {
            title: "票券类型",
            dataIndex: "type",
            scopedSlots: { customRender: "ticketType" }
        },
            {
            title: "总次数",
            dataIndex: "total",
            scopedSlots: { customRender: "total" }
        },
        {
            title: "剩余次数",
            dataIndex: "residueNum",
            scopedSlots: { customRender: "residueNum" }
        },
        {
            title: "到期日",
            dataIndex: "expireDay",
            scopedSlots: { customRender: "expireDay" }
        },
        {
            title: "销售单价",
            dataIndex: "beforeDiscountPrice",
            scopedSlots: { customRender: "myToFixed2" }
        },
        {
            title: "购买单价",
            dataIndex: "payAmounts",
            scopedSlots: { customRender: "payAmounts" }
        },
        {
            title: "购买金额",
            dataIndex: "payAmount",
            scopedSlots: { customRender: "myToFixed2" }
        },
        {
            title: "操作",
            key: "action",
            scopedSlots: { customRender: "action" }
        }
    ]
    const columnsRefund = [
        {
            title: "退款单号",
            dataIndex: "refundNo",
            scopedSlots: { customRender: "refundNo" }
        },
        {
            title: "申请子订单",
            dataIndex: "transNo"
        },
        {
            title: "退款商品",
            dataIndex: "goodsName",
            scopedSlots: { customRender: "goodsName" }
        },
        {
            title: "状态",
            dataIndex: "auditState",
            scopedSlots: { customRender: "auditState" }
        },
        {
            title: "退款状态",
            dataIndex: "state",
            scopedSlots: { customRender: "state" }
        },
        {
            title: "退款状态说明",
            dataIndex: "thirdPartyMsg",
            scopedSlots: { customRender: "thirdPartyMsg" }
        },
        {
            title: "申请金额",
            dataIndex: "refundAmount",
            scopedSlots: { customRender: "myToFixed2" }
        },
        {
            title: "申请人",
            dataIndex: "operator",
            scopedSlots: { customRender: "operator" }
        },
        {
            title: "审核人",
            dataIndex: "auditer",
            scopedSlots: { customRender: "auditer" }
        },
        {
            title: "创建时间",
            dataIndex: "applyTime",
            scopedSlots: { customRender: "applyTime" }
        },
        {
            title: "审核完成时间",
            dataIndex: "auditTime",
            scopedSlots: { customRender: "auditTime" }
        }
    ];
    const columnsFrozen = [
        {
            title: "商品名称",
            dataIndex: "afterSalesName",
        },
        {
            title: "冻结期间",
            dataIndex: "frozenDate",
            scopedSlots: { customRender: "frozenDate" }
        },
        {
            title: "冻结天数",
            dataIndex: "frozenDay",
            scopedSlots: { customRender: "frozenDay" }
        },
        {
            title: "原有效期",
            dataIndex: "originalValidTime",
            scopedSlots: { customRender: "originalValidTime" }
        },
        {
            title: "新有效期",
            dataIndex: "nowValidTime",
            scopedSlots: { customRender: "nowValidTime" }
        },
    ];
    const columnsValidityReset = [
        {
            title: "商品名称",
            dataIndex: "afterSalesName",
        },
        {
            title: "原有效期",
            dataIndex: "originalValidTime",
            scopedSlots: { customRender: "originalValidTime" }
        },
        {
            title: "新有效期",
            dataIndex: "nowValidTime",
            scopedSlots: { customRender: "nowValidTime" }
        },
    ]
    const columnsExchangeCard = [
        {
            title: "商品名称",
            dataIndex: "afterSalesName",
        },
        {
            title: "原卡号",
            dataIndex: "origCardNo",
        },
        {
            title: "新卡号",
            dataIndex: "nowCardNo",
        },
    ]
    const columnsDelay = [
        {
            title: "商品名称",
            dataIndex: "afterSalesName",
        },
        {
            title: "原有效期",
            dataIndex: "ticketValidStartTime",
            scopedSlots: { customRender: "originalValidTime"}
        },
        {
            title: "续期",
            dataIndex: "delayEndTime",
        },
    ]
    export default {
        name: "buyOrder",
        components: {
            memberOrderForbidden,
            orderRefund
        },
        data() {
            const tabListNoTitle = [
                {
                    key: '1',
                    tab: '商品明细'
                },
                {
                    key: '2',
                    tab: '退款信息'
                }
            ]
            return {
                isCanRefund: false,
                columnsFrozen,
                columnsValidityReset,
                columnsExchangeCard,
                columnsDelay,
                tabListNoTitle,
                noTitleKey: '1',
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                columnsRefund,
                detailData: {},
                successMsg: '',
                span: 8,
                orderDetail: {},
                spinning: false
            };
        },
        computed: {
            ...mapGetters(["shopId"]),
            upgradeBeforeTickets() {
                if (this.detailData.category == 'Upgrade' && this.dataSource.length) {
                    return this.dataSource.filter(el => el.ticketMark == 1 || this.detailData.afterSalesData[0].upgradeBeforeTickets == el.businessId)
                }
            },
            upgradeAfterTickets() {
                if (this.detailData.category == 'Upgrade' && this.dataSource.length) {
                    return this.dataSource.filter(el => el.ticketMark == 2 || this.detailData.afterSalesData[0].upgradeAfterTickets == el.businessId)
                }
            }
        },
        methods: {
            // 发起OTA退款
            confirm() {
                this.orderDetail.orderGoods.forEach(el => {
                    el.applyRefundAmount = el.payAmount;
                    el.businessId = el.userTicketNo;
                });
                this.$api.order.refundOrderList({
                    body: {
                        ...this.orderDetail,
                        category: this.orderDetail.categoryEn,
                        transNo: this.orderDetail.tradeNo,
                        platform: this.orderDetail.platformName,
                        refundMode: 0,
                        reason: 'OTA客诉退款',
                        remarkCategoryCode: 'categoryCode',
                        remarkCategoryName: '客诉补偿',
                        goodsReturn: this.orderDetail.orderGoods,
                        account: this.orderDetail.phone,
                        shopId: this.shopId,
                        verify: 'uncheck',
                    }
                })
                .then(res => {
                    this.getOrder();
                    this.getList()
                    this.$message.success('操作成功，可去审核列表查看审核情况')
                })
                .catch(res => {
                    this.confirmLoading = false
                })
            },
            onTabChange(noTitleKey,keyName) {
                this[keyName] = noTitleKey;
                this.noTitleKey = noTitleKey;
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },
            // 获取订单列表
            getOrder() {
                if (!this.$route.params.orderId || this.$route.params.orderId == 0) return;
                this.spinning = true;
                this.$api.order.orderSearch({
                    query: {
                        pageNum: 1,
                        pageSize: 1,
                        goodsType: "TICKET",
                        tradeNoOnly: true,
                        tradeNo: this.$route.params.orderId,
                    },
                }).then(res => {
                    res.list.forEach( el => {
                        this.isCanRefund = Boolean(["已支付", "部分退款", "退款中"].find(item => item == el.tradeState)) && Boolean(el.categoryEn == 'Buy' || el.categoryEn == 'GoodsGrant') && Boolean(el.platformName != "积分小程序")
                    });
                    this.orderDetail = res.list[0];
                    this.getList();
                })
            },
            // 获取购票订单列表
            getList() {
                if (!this.$route.params.orderId || this.$route.params.orderId == 0) return;
                this.$api.order.getOrderDetail({
                    body: {
                        transNo: this.$route.params.orderId,
                    }
                }).then(res => {
                    res.refundAmount = 0;
                    res.refundListDetail = [];

                    res.orderTickets && res.orderTickets.forEach((el, index) => {
                        if (el.stateStr == '已关闭' || el.stateStr == '待支付' || el.stateStr == "待付款") {
                            el.closeNavigate = true;
                            el.businessId = el.invalidType = el.residueNum = el.ticketStateStr = el.expireDay = "-";
                        }
                        res.refundListDetail.push(el);
                        el.gifts && res.refundListDetail.push(...el.gifts);
                    });

                    res.refundListDetail.forEach( (el, index) => {
                        el.isNotRefund = !Boolean(el.residueNum) || Boolean(['isForbidden', 'isFrozen', 'isInvalid', 'isLocked'].find(item => el[item]))
                        el.refundAmount = el.refundAmount || 0;
                        res.refundAmount += el.refundAmount;
                        el.refundCount = 0;
                        el.key = index;
                    });
                    res.afterSalesData = res.afterSales && [{
                        ...res.afterSales,
                        ...JSON.parse(res.afterSales.extend)
                    }];
                    this.dataSource = res.orderTickets || [];
                    res.category = this.orderDetail.categoryEn;
                    this.detailData = res;
                    if (res.refundGoods && res.refundGoods.length > 0) {
                        let auditTime = false;
                        res.refundGoods.forEach(e => {
                            auditTime = this.$moment(e.auditTime).diff('2022-12-15') > 0;
                        })
                        if((res.payMode == 11 && res.isManualPayment) || res.payMode == 3 || res.payMode == 4 || (this.$moment(res.payTime).diff('2022-12-15') < 0 && auditTime)) {
                            this.successMsg = '退款成功（走线下）';
                        }else {
                            this.successMsg = '退款成功（系统已退）';
                        }
                        if(res.platform == '第三方购买' && res.category == 'Buy') {
                            this.successMsg = '退款成功（OTA已退）';
                        }
                    }
                    this.spinning = false;
                });
            },
            onClickGiveTicket(id) {
                this.$router.push({name: "sendDetail", query: {id: id}})
            },
            /**
             * @forbidden 禁用/解禁
             */
            forbidden(userTicketId, forbidden) {
                this.$refs.forbiddenModal.show(userTicketId, forbidden);
            },
            toRefundOrder() {
                if (this.orderDetail.tradeState == "退款中") {
                    this.$message.warn('交易单处于"退款中"，无法继续发起退款');
                    return
                }
                if (this.$moment().day() == 1 || (this.$moment().format('H') < 10 || this.$moment().format('H') >= 23)) {
                    this.$message.warn('当前银联系统收款账户清算中，暂不支持退款。每周一全天和其他日期的23点-次日10点管理后台和小程序都不支持退款。');
                    return
                };
                this.$refs.orderRefund.visibleRefund = true;
            },
        },
        created() {},
        mounted() {
            this.getOrder();
        },
        watch: {
            '$route'(val) {
                this.dataSource = [];
                this.detailData = {};
                this.orderDetail = {};
                val.name == 'buyOrder' && this.getOrder();
            }
        }
    };
</script>
<style lang="scss">
.title-ticket {
    margin-bottom: 8px;
    font-size: 16px;
    color: #000;
    font-weight: 700;
}
.tr-active {
    background-color: #fff6ee;
}
.buyOrder {
    padding: 0 16px;
    &-title {
        font-weight: 500;
        font-size: 16px;
    }
}
</style>
